import React from 'react';
import './ScheduleModal.css';

const RoomSelectionInput = ({ selectedRoom, openRoomSelection }) => {
  return (
    <div className='flex-columns flex-1' style={{ marginTop: 16 }}>
      <div>
        <span className='create-schedule-label'>Room Assignment</span>
      </div>
      <div>
        <div className='flex-1 flex-rows create-schedule-date-input' style={{ marginTop: 8 }}>
          <div className='flex-columns flex-1' style={{ marginLeft: 16, justifyContent: 'center' }}>
            <span className='create-schedule-input-text'>{selectedRoom}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RoomSelectionInput;
